<template>
    <modal :open="localOpen" @close="$emit('close')">
        <template #header>
            Edit Name
        </template>
        <template #default>
            <form @submit.prevent="processForm" :id="`editAestheticProfileName${profile.id}`">
                <form-group :valid="localNameValid">
                    <form-label>Aesthetic Profile Name:</form-label>
                    <form-input v-model="localName" @input="validateForm" />
                </form-group>
            </form>
        </template>

        <template #buttons>
            <ui-button @click="localOpen=false" block="sm" :underline="true" color="secondary" :disabled="buttonsLoading" :loading="buttonsLoading" class="order-2 order-md-1">
                Cancel
            </ui-button>
            <ui-button :submit="true" :form="`editAestheticProfileName${profile.id}`" block="sm" :disabled="buttonsLoading" :loading="buttonsLoading" class="order-1 order-md-2 mb-3 mb-md-0">
                Submit
            </ui-button>
        </template>
    </modal>
</template>

<script type="text/javascript">
    import CommonComponents from '@/components/Common.vue';

    import Api from '@/classes/Api.js';
    import ApiObject from '@/classes/ApiObject.js';
    import { UseUIStore } from '@/store/UI.js';

    export default {
        components: {
            ...CommonComponents,
        },

        setup() {
            return {
                uiStore: UseUIStore(),
            };
        },

        data() {
            return {
                localOpen: true,

                localName: null,

                startValidation: false,
                localNameValid: null,

                buttonsLoading: false,
            };
        },

        props: {
            profile: {
                type: ApiObject,
                required: true,
            },

            open: {
                type: Boolean,
                default: true,
            },
        },

        emits: ['saved', 'close'],
        
        created() {
            this.localName = this.profile.name;
            this.localOpen = this.open;
        },

        watch: {
            open() {
                this.localOpen = this.open;
            },
        },

        methods: {
            validateForm() {
                if (!this.startValidation) return;

                let valid = true;
                this.localNameValid = null;

                if (!this.localName) {
                    valid = false;
                    this.localNameValid = false;
                }

                return valid;
            },

            async processForm() {
                this.startValidation = true;
                if (!this.validateForm()) {
                    this.uiStore.toast({
                        error: true,
                        title: 'Name is Required',
                        message: 'Please enter the aesthetic profile name',
                    });

                    return;
                }

                this.buttonsLoading = true;

                let data = {
                    name: this.localName,
                };

                let response = await Api.patch(`travelers/ai/profile/${this.profile.id}/name`, data);

                if ((response.valid) && (response.results) && (!response.results.error)) {
                    this.$emit('saved');
                    this.localOpen = false;
                }
                else {
                    let error = 'Could not complete request';
                    if ((response.results) && (response.results.error)) {
                        if (response.results.error.message) error = response.results.error.message;
                        else error = response.results.error;
                    }

                    this.uiStore.toast({
                        error: true,
                        title: 'Error',
                        message: error,
                    });

                    this.submitError = true;
                }

                this.buttonsLoading = false;
            }
        },
    };

</script>
